"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.policyFieldImportance = void 0;
const enums_1 = require("./enums");
/**
 * Importance definition per field, per policy type.
 */
/**
 * Importance definition per field, per policy type.
 */
exports.policyFieldImportance = {
    id: {},
    issuer: {
        PERSONAL_AUTO: enums_1.Importance.LOW,
        HOMEOWNERS: enums_1.Importance.LOW,
        RENTERS: enums_1.Importance.LOW,
    },
    policyNumber: {
        PERSONAL_AUTO: enums_1.Importance.LOW,
        HOMEOWNERS: enums_1.Importance.LOW,
        RENTERS: enums_1.Importance.LOW,
    },
    dateRetrieved: {
        PERSONAL_AUTO: enums_1.Importance.LOW,
        HOMEOWNERS: enums_1.Importance.LOW,
        RENTERS: enums_1.Importance.LOW,
    },
    hasAtFaultAccident: {},
    policyType: {
        PERSONAL_AUTO: enums_1.Importance.CRITICAL,
        HOMEOWNERS: enums_1.Importance.CRITICAL,
        RENTERS: enums_1.Importance.CRITICAL,
    },
    policyTermMonths: {
        PERSONAL_AUTO: enums_1.Importance.LOW,
        HOMEOWNERS: enums_1.Importance.LOW,
        RENTERS: enums_1.Importance.LOW,
    },
    renewalDate: {
        PERSONAL_AUTO: enums_1.Importance.LOW,
        HOMEOWNERS: enums_1.Importance.CRITICAL,
        RENTERS: enums_1.Importance.CRITICAL,
    },
    issueDate: {
        PERSONAL_AUTO: enums_1.Importance.LOW,
        HOMEOWNERS: enums_1.Importance.CRITICAL,
        RENTERS: enums_1.Importance.CRITICAL,
    },
    canceledDate: {
        PERSONAL_AUTO: enums_1.Importance.HIGH,
        HOMEOWNERS: enums_1.Importance.HIGH,
        RENTERS: enums_1.Importance.LOW,
    },
    premiumCents: {
        PERSONAL_AUTO: enums_1.Importance.CRITICAL,
        HOMEOWNERS: enums_1.Importance.CRITICAL,
        RENTERS: enums_1.Importance.LOW,
    },
    policyHolder: {
        name: {
            firstName: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
                RENTERS: enums_1.Importance.CRITICAL,
            },
            middleName: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
                RENTERS: enums_1.Importance.CRITICAL,
            },
            lastName: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
                RENTERS: enums_1.Importance.CRITICAL,
            },
        },
        address: {
            number: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
                RENTERS: enums_1.Importance.LOW,
            },
            street: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
                RENTERS: enums_1.Importance.LOW,
            },
            type: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
                RENTERS: enums_1.Importance.LOW,
            },
            sec_unit_type: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
                RENTERS: enums_1.Importance.LOW,
            },
            sec_unit_num: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
                RENTERS: enums_1.Importance.LOW,
            },
            city: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
                RENTERS: enums_1.Importance.LOW,
            },
            state: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
                RENTERS: enums_1.Importance.LOW,
            },
            zip: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
                RENTERS: enums_1.Importance.LOW,
            },
            plus4: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
                RENTERS: enums_1.Importance.LOW,
            },
            suffix: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
                RENTERS: enums_1.Importance.LOW,
            },
            prefix: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
                RENTERS: enums_1.Importance.LOW,
            },
        },
        addressRaw: {
            PERSONAL_AUTO: enums_1.Importance.CRITICAL,
            HOMEOWNERS: enums_1.Importance.CRITICAL,
            RENTERS: enums_1.Importance.LOW,
        },
        phoneNumber: {
            PERSONAL_AUTO: enums_1.Importance.CRITICAL,
            HOMEOWNERS: enums_1.Importance.CRITICAL,
            RENTERS: enums_1.Importance.LOW,
        },
        email: {
            PERSONAL_AUTO: enums_1.Importance.CRITICAL,
            HOMEOWNERS: enums_1.Importance.CRITICAL,
            RENTERS: enums_1.Importance.CRITICAL,
        },
        isHomeOwner: {
            PERSONAL_AUTO: enums_1.Importance.HIGH,
            HOMEOWNERS: enums_1.Importance.CRITICAL,
            RENTERS: enums_1.Importance.LOW,
        },
        birthday: {},
        birthdayRange: {},
        tenureInYears: {
            PERSONAL_AUTO: enums_1.Importance.HIGH,
            HOMEOWNERS: enums_1.Importance.HIGH,
            RENTERS: enums_1.Importance.LOW,
        },
        residenceStatus: {
            PERSONAL_AUTO: enums_1.Importance.MEDIUM,
            RENTERS: enums_1.Importance.LOW,
        },
        isMilitary: {
            PERSONAL_AUTO: enums_1.Importance.LOW,
            HOMEOWNERS: enums_1.Importance.LOW,
            RENTERS: enums_1.Importance.LOW,
        },
    },
    operators: [
        {
            name: {
                firstName: {
                    PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                },
                middleName: {
                    PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                },
                lastName: {
                    PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                },
            },
            gender: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
            },
            maritalStatus: {
                PERSONAL_AUTO: enums_1.Importance.HIGH,
            },
            relationship: {
                PERSONAL_AUTO: enums_1.Importance.MEDIUM,
            },
            birthday: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
            },
            isPrimary: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
            },
            occupation: {
                PERSONAL_AUTO: enums_1.Importance.MEDIUM,
            },
            education: {
                PERSONAL_AUTO: enums_1.Importance.MEDIUM,
            },
            rawEducation: {},
            rawRelationship: {},
            birthdayRange: {
                start: {
                    PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                },
                end: {
                    PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                },
            },
            ageLicensed: {
                PERSONAL_AUTO: enums_1.Importance.MEDIUM,
            },
            ageLicensedInternationally: {},
            driversLicenseState: {
                PERSONAL_AUTO: enums_1.Importance.HIGH,
            },
            driversLicenseStatus: {
                PERSONAL_AUTO: enums_1.Importance.LOW,
            },
            driversLicenseNumber: {
                PERSONAL_AUTO: enums_1.Importance.HIGH,
            },
            hasFullDriversLicenseNumber: {
                PERSONAL_AUTO: enums_1.Importance.LOW,
            },
            email: {
                PERSONAL_AUTO: enums_1.Importance.LOW,
            },
            experienceYears: {},
            address: {},
            addressRaw: {},
            phoneNumber: {},
            financialResponsibilityCases: [
                {
                    state: {
                        PERSONAL_AUTO: enums_1.Importance.HIGH,
                    },
                    type: {
                        PERSONAL_AUTO: enums_1.Importance.HIGH,
                    },
                    caseNumber: {
                        PERSONAL_AUTO: enums_1.Importance.HIGH,
                    },
                },
            ],
        },
    ],
    property: {
        address: {
            number: {
                RENTERS: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
            },
            street: {
                RENTERS: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
            },
            type: {
                RENTERS: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
            },
            sec_unit_type: {
                RENTERS: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
            },
            sec_unit_num: {
                RENTERS: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
            },
            city: {
                RENTERS: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
            },
            state: {
                RENTERS: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
            },
            zip: {
                RENTERS: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
            },
            plus4: {
                RENTERS: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
            },
            suffix: {
                RENTERS: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
            },
            prefix: {
                RENTERS: enums_1.Importance.CRITICAL,
                HOMEOWNERS: enums_1.Importance.CRITICAL,
            },
        },
        addressRaw: {
            RENTERS: enums_1.Importance.CRITICAL,
            HOMEOWNERS: enums_1.Importance.CRITICAL,
        },
        architecturalStyle: {
            RENTERS: enums_1.Importance.LOW,
            HOMEOWNERS: enums_1.Importance.LOW,
        },
        squareFeet: {
            HOMEOWNERS: enums_1.Importance.CRITICAL,
        },
        usage: {
            RENTERS: enums_1.Importance.LOW,
            HOMEOWNERS: enums_1.Importance.CRITICAL,
        },
        dwellingType: {
            RENTERS: enums_1.Importance.LOW,
            HOMEOWNERS: enums_1.Importance.CRITICAL,
        },
        estimatedReplacementCost: {
            RENTERS: enums_1.Importance.LOW,
            HOMEOWNERS: enums_1.Importance.LOW,
        },
        wallType: {
            RENTERS: enums_1.Importance.LOW,
            HOMEOWNERS: enums_1.Importance.LOW,
        },
        purchaseDate: {
            RENTERS: enums_1.Importance.LOW,
            HOMEOWNERS: enums_1.Importance.LOW,
        },
        numberOfHouseholdMembers: {},
        numberOfStories: {
            RENTERS: enums_1.Importance.LOW,
            HOMEOWNERS: enums_1.Importance.LOW,
        },
        yearBuilt: {
            RENTERS: enums_1.Importance.MEDIUM,
            HOMEOWNERS: enums_1.Importance.CRITICAL,
        },
        constructionType: {
            RENTERS: enums_1.Importance.LOW,
            HOMEOWNERS: enums_1.Importance.HIGH,
        },
        foundationType: {
            RENTERS: enums_1.Importance.LOW,
            HOMEOWNERS: enums_1.Importance.LOW,
        },
        composition: [
            {
                descriptionRaw: {
                    RENTERS: enums_1.Importance.LOW,
                    HOMEOWNERS: enums_1.Importance.HIGH,
                },
                type: {
                    RENTERS: enums_1.Importance.LOW,
                    HOMEOWNERS: enums_1.Importance.HIGH,
                },
                shape: {
                    RENTERS: enums_1.Importance.LOW,
                    HOMEOWNERS: enums_1.Importance.HIGH,
                },
                materials: [
                    {
                        RENTERS: enums_1.Importance.LOW,
                        HOMEOWNERS: enums_1.Importance.HIGH,
                    },
                ],
                percentage: {
                    RENTERS: enums_1.Importance.LOW,
                    HOMEOWNERS: enums_1.Importance.HIGH,
                },
            },
        ],
        numberOfKitchens: {
            RENTERS: enums_1.Importance.LOW,
            HOMEOWNERS: enums_1.Importance.LOW,
        },
        numberOfBathrooms: {
            RENTERS: enums_1.Importance.LOW,
            HOMEOWNERS: enums_1.Importance.LOW,
        },
        numberOfFireplaces: {
            RENTERS: enums_1.Importance.LOW,
            HOMEOWNERS: enums_1.Importance.LOW,
        },
        garages: [
            {
                type: {
                    RENTERS: enums_1.Importance.LOW,
                    HOMEOWNERS: enums_1.Importance.LOW,
                },
                capacity: {
                    RENTERS: enums_1.Importance.LOW,
                    HOMEOWNERS: enums_1.Importance.LOW,
                },
            },
        ],
        distanceToFireHydrantInFeet: {
            RENTERS: enums_1.Importance.MEDIUM,
            HOMEOWNERS: enums_1.Importance.MEDIUM,
        },
        distanceToFireDepartmentInMiles: {
            RENTERS: enums_1.Importance.MEDIUM,
            HOMEOWNERS: enums_1.Importance.MEDIUM,
        },
        features: {
            hasFireAlarm: {
                RENTERS: enums_1.Importance.LOW,
                HOMEOWNERS: enums_1.Importance.LOW,
            },
            hasBurglarAlarm: {
                RENTERS: enums_1.Importance.LOW,
                HOMEOWNERS: enums_1.Importance.LOW,
            },
            hasSupplementalHeating: {
                RENTERS: enums_1.Importance.LOW,
                HOMEOWNERS: enums_1.Importance.LOW,
            },
        },
        ageOfRoofInYears: {},
    },
    householdMembers: [
        {
            name: {
                firstName: {
                    RENTERS: enums_1.Importance.LOW,
                    HOMEOWNERS: enums_1.Importance.MEDIUM,
                },
                middleName: {
                    RENTERS: enums_1.Importance.LOW,
                    HOMEOWNERS: enums_1.Importance.MEDIUM,
                },
                lastName: {
                    RENTERS: enums_1.Importance.LOW,
                    HOMEOWNERS: enums_1.Importance.MEDIUM,
                },
            },
            birthdayRange: {
                start: {
                    RENTERS: enums_1.Importance.CRITICAL,
                    HOMEOWNERS: enums_1.Importance.CRITICAL,
                },
                end: {
                    RENTERS: enums_1.Importance.CRITICAL,
                    HOMEOWNERS: enums_1.Importance.CRITICAL,
                },
            },
            gender: {
                RENTERS: enums_1.Importance.LOW,
                HOMEOWNERS: enums_1.Importance.LOW,
            },
            occupation: {
                RENTERS: enums_1.Importance.LOW,
                HOMEOWNERS: enums_1.Importance.LOW,
            },
            birthday: {},
            relationship: {
                RENTERS: enums_1.Importance.LOW,
                HOMEOWNERS: enums_1.Importance.LOW,
            },
        },
    ],
    coverages: [
        {
            name: {
                HOMEOWNERS: enums_1.Importance.HIGH,
                RENTERS: enums_1.Importance.LOW,
            },
            rawName: {
                HOMEOWNERS: enums_1.Importance.HIGH,
                RENTERS: enums_1.Importance.LOW,
            },
            perOccurrenceLimitCents: {
                HOMEOWNERS: enums_1.Importance.MEDIUM,
                RENTERS: enums_1.Importance.LOW,
            },
            perPersonLimitCents: {
                RENTERS: enums_1.Importance.LOW,
            },
            maxMonthsLimit: {
                HOMEOWNERS: enums_1.Importance.LOW,
                RENTERS: enums_1.Importance.LOW,
            },
            premiumCents: {
                HOMEOWNERS: enums_1.Importance.HIGH,
                RENTERS: enums_1.Importance.LOW,
            },
            isDeclined: {
                HOMEOWNERS: enums_1.Importance.HIGH,
                RENTERS: enums_1.Importance.LOW,
            },
            deductibleCents: {
                HOMEOWNERS: enums_1.Importance.LOW,
                RENTERS: enums_1.Importance.LOW,
            },
            hurricaneDeductibleCents: {
                HOMEOWNERS: enums_1.Importance.HIGH,
                RENTERS: enums_1.Importance.LOW,
            },
            windstormDeductibleCents: {
                HOMEOWNERS: enums_1.Importance.LOW,
                RENTERS: enums_1.Importance.LOW,
            },
            earthquakeDeductibleCents: {
                HOMEOWNERS: enums_1.Importance.LOW,
                RENTERS: enums_1.Importance.LOW,
            },
        },
    ],
    mortgages: [
        {
            type: {
                HOMEOWNERS: enums_1.Importance.HIGH,
            },
            loanNumber: {
                HOMEOWNERS: enums_1.Importance.HIGH,
            },
            lienHolder: {
                HOMEOWNERS: enums_1.Importance.HIGH,
            },
            lienHolderAddress: {
                number: {
                    HOMEOWNERS: enums_1.Importance.HIGH,
                },
                street: {
                    HOMEOWNERS: enums_1.Importance.HIGH,
                },
                type: {
                    HOMEOWNERS: enums_1.Importance.HIGH,
                },
                sec_unit_type: {
                    HOMEOWNERS: enums_1.Importance.HIGH,
                },
                sec_unit_num: {
                    HOMEOWNERS: enums_1.Importance.HIGH,
                },
                city: {
                    HOMEOWNERS: enums_1.Importance.HIGH,
                },
                state: {
                    HOMEOWNERS: enums_1.Importance.HIGH,
                },
                zip: {
                    HOMEOWNERS: enums_1.Importance.HIGH,
                },
                plus4: {
                    HOMEOWNERS: enums_1.Importance.HIGH,
                },
                suffix: {
                    HOMEOWNERS: enums_1.Importance.HIGH,
                },
                prefix: {
                    HOMEOWNERS: enums_1.Importance.HIGH,
                },
            },
        },
    ],
    vehicles: [
        {
            vin: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
            },
            year: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
            },
            make: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
            },
            model: {
                PERSONAL_AUTO: enums_1.Importance.CRITICAL,
            },
            garagingLocation: {
                number: {
                    PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                },
                street: {
                    PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                },
                type: {
                    PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                },
                sec_unit_type: {
                    PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                },
                sec_unit_num: {
                    PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                },
                city: {
                    PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                },
                state: {
                    PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                },
                zip: {
                    PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                },
                plus4: {
                    PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                },
                suffix: {
                    PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                },
                prefix: {
                    PERSONAL_AUTO: enums_1.Importance.CRITICAL,
                },
            },
            annualMileage: {
                PERSONAL_AUTO: enums_1.Importance.HIGH,
            },
            use: {
                PERSONAL_AUTO: enums_1.Importance.LOW,
            },
            ownershipStatus: {
                PERSONAL_AUTO: enums_1.Importance.HIGH,
            },
            type: {
                PERSONAL_AUTO: enums_1.Importance.LOW,
            },
            inStorage: {
                PERSONAL_AUTO: enums_1.Importance.LOW,
            },
            isRideSharing: {
                PERSONAL_AUTO: enums_1.Importance.MEDIUM,
            },
            bodyStyle: {
                PERSONAL_AUTO: enums_1.Importance.LOW,
            },
            purchaseDate: {
                PERSONAL_AUTO: enums_1.Importance.LOW,
            },
            antiTheftDevices: {
                PERSONAL_AUTO: enums_1.Importance.LOW,
            },
            lienHolder: {
                PERSONAL_AUTO: enums_1.Importance.MEDIUM,
            },
            lienHolderAddress: {
                number: {
                    PERSONAL_AUTO: enums_1.Importance.MEDIUM,
                },
                street: {
                    PERSONAL_AUTO: enums_1.Importance.MEDIUM,
                },
                type: {
                    PERSONAL_AUTO: enums_1.Importance.MEDIUM,
                },
                sec_unit_type: {
                    PERSONAL_AUTO: enums_1.Importance.MEDIUM,
                },
                sec_unit_num: {
                    PERSONAL_AUTO: enums_1.Importance.MEDIUM,
                },
                city: {
                    PERSONAL_AUTO: enums_1.Importance.MEDIUM,
                },
                state: {
                    PERSONAL_AUTO: enums_1.Importance.MEDIUM,
                },
                zip: {
                    PERSONAL_AUTO: enums_1.Importance.MEDIUM,
                },
                plus4: {
                    PERSONAL_AUTO: enums_1.Importance.MEDIUM,
                },
                suffix: {
                    PERSONAL_AUTO: enums_1.Importance.MEDIUM,
                },
                prefix: {
                    PERSONAL_AUTO: enums_1.Importance.MEDIUM,
                },
            },
            premiumCents: {
                PERSONAL_AUTO: enums_1.Importance.LOW,
            },
            garagingLocationRaw: {},
            coverages: [
                {
                    name: {
                        PERSONAL_AUTO: enums_1.Importance.HIGH,
                    },
                    premiumCents: {
                        PERSONAL_AUTO: enums_1.Importance.LOW,
                    },
                    isDeclined: {
                        PERSONAL_AUTO: enums_1.Importance.LOW,
                    },
                    perPersonLimitCents: {
                        PERSONAL_AUTO: enums_1.Importance.HIGH,
                    },
                    perAccidentLimitCents: {
                        PERSONAL_AUTO: enums_1.Importance.HIGH,
                    },
                    deductibleCents: {
                        PERSONAL_AUTO: enums_1.Importance.HIGH,
                    },
                    glassDeductibleCents: {
                        PERSONAL_AUTO: enums_1.Importance.LOW,
                    },
                    perDayLimitCents: {
                        PERSONAL_AUTO: enums_1.Importance.HIGH,
                    },
                    perWeekLimitCents: {
                        PERSONAL_AUTO: enums_1.Importance.HIGH,
                    },
                    perMonthLimitCents: {
                        PERSONAL_AUTO: enums_1.Importance.HIGH,
                    },
                },
            ],
        },
    ],
    incidents: [
        {
            id: {
                PERSONAL_AUTO: enums_1.Importance.LOW,
            },
            date: {
                PERSONAL_AUTO: enums_1.Importance.HIGH,
            },
            descriptionRaw: {
                PERSONAL_AUTO: enums_1.Importance.LOW,
            },
            state: {
                PERSONAL_AUTO: enums_1.Importance.LOW,
            },
            type: {
                PERSONAL_AUTO: enums_1.Importance.HIGH,
            },
            typeDetails: {
                PERSONAL_AUTO: enums_1.Importance.MEDIUM,
            },
            paidAmountCents: {
                PERSONAL_AUTO: enums_1.Importance.HIGH,
            },
            atFault: {
                PERSONAL_AUTO: enums_1.Importance.HIGH,
            },
            liabilityMedicalPaidAmountCents: {
                PERSONAL_AUTO: enums_1.Importance.HIGH,
            },
            driverNameRaw: {},
            driver: {
                PERSONAL_AUTO: enums_1.Importance.HIGH,
            },
        },
    ],
};
